import { render, staticRenderFns } from "./ArticleUnits.vue?vue&type=template&id=b0519efa&scoped=true&"
import script from "./ArticleUnits.vue?vue&type=script&lang=js&"
export * from "./ArticleUnits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0519efa",
  null
  
)

export default component.exports